<template>
  <div>
    <b-modal
      v-model="modalShow"
      title="Type of event"
      header-bg-variant="primary"
      header-text-variant="white"
      size="md"
      no-close-on-backdrop
      centered
    >
      <b-form-group
        v-if="!selectedLocation"
        label="Location"
        class="w-100 mr-4"
        :state="!error"
        :invalid-feedback="error ? `This field is required` : ''"
      >
        <template v-slot:label>
          Location
        </template>
        <v-select
          :clearable="false"
          class="w-100"
          v-model="location"
          :options="locationOptions"
        ></v-select>
      </b-form-group>
      <template v-slot:modal-footer>
        <div class="text-right mt-1 mr-2">
          <b-button @click="$emit('onHidden')" variant="secondary">
            Cancel
          </b-button>
          <b-button class="ml-2" @click="submitScheduleEvent" variant="primary">
            Confirm
          </b-button>
        </div>
      </template>
      <b-form-group
        label="What kind of event do you want to create?"
        v-slot="{ ariaDescribedby }"
      >
        <b-form-radio-group
          :options="options"
          v-model="selectedOption"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          stacked
        ></b-form-radio-group>
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "EventTypeSelectorModal",
  data() {
    return {
      showEventTypeSelectorModal: false,
      location: null,
      options: [
        { value: "appointment", text: "Appointment" },
        { value: "groupSession", text: "Group session" },
        { value: "loc", text: "Day in level of care" },
        { value: "other", text: "Other (users only)" }
      ],
      selectedOption: "appointment",
      error: false
    };
  },
  methods: {
    async submitScheduleEvent() {
      this.validate();
      if (!this.error) {
        if (this.selectedLocation != null) {
          this.location = {
            ...this.selectedLocation,
            value: this.selectedLocation.id
          };
        }
        this.$emit("selectEditor", this.selectedOption, this.location);
      }
    },
    validate() {
      this.error = false;
      if (!this.location && this.selectedLocation === null) {
        this.error = true;
      }
    }
  },
  computed: {
    ...mapGetters("client", ["selectedLocation"]),
    ...mapState("layout", {
      locationOptions: state =>
        state.currentUser?.accessToLocations.map(location => ({
          value: location.id,
          label: location.name
        }))
    }),
    modalShow: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
